import { useEffect, useRef, useState } from 'react';

import { EMPTY_FUNCTION, INPUT_DEBOUNCE } from '../../../constants';

interface UseDebounceProps {
  typed_value: string;
  debounce: number;
  callback: () => void;
}
export function useDebounce({
  typed_value = '',
  debounce,
  callback = EMPTY_FUNCTION,
}: UseDebounceProps) {
  const [is_typing, setTyping] = useState(false);
  const lastValueRef = useRef(typed_value);

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (lastValueRef.current === typed_value) {
      return;
    }
    lastValueRef.current = typed_value;

    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      callback();
      typingTimeoutRef.current = setTimeout(() => {
        setTyping(false);
      }, INPUT_DEBOUNCE);
    }, debounce);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    };
  }, [typed_value, callback, debounce]);

  return { is_typing, setTyping };
}
